<div class="email-settings-component">
  <div class="top-bar flex flex-row justify-between items-center px-3">
    <h2>Loader Integration</h2>
    <div class="flex flex-row gap-1">
      <button
        *saFeatureFlag="'loaderAnalyticsV2'"
        mat-flat-button
        color="primary"
        [routerLink]="['/', 'loader-analytics-dashboard-v2']"
      >
        ANALYTICS
      </button>
      <button mat-flat-button color="primary" (click)="addForm()">ADD NEW</button>
    </div>
  </div>

  <div class="table-wrap">
    <table mat-table [dataSource]="activeDataSource" matSort (matSortChange)="sortTable($event)">
      <ng-container matColumnDef="loader">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Loader</th>
        <td
          mat-cell
          *matCellDef="let emailDetails"
          saAutomatedSelector="loader__email"
          automatedname="email"
          (click)="router.navigate(['/loader-integration-v2/detail', emailDetails.id])"
        >
          <a [routerLink]="['/loader-integration-v2/detail', emailDetails.id]">{{ emailDetails.loader.name }}</a>
        </td>
      </ng-container>

      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
        <td
          mat-cell
          *matCellDef="let emailDetails"
          saAutomatedSelector="loader__email"
          automatedname="email"
          (click)="router.navigate(['/loader-integration-v2/detail', emailDetails.id])"
        >
          <h4>{{ emailDetails.email }}</h4>
        </td>
      </ng-container>

      <ng-container matColumnDef="import">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Most Recent Import</th>
        <td
          mat-cell
          *matCellDef="let emailDetails"
          (click)="router.navigate(['/loader-integration-v2/detail', emailDetails.id])"
        >
          {{ emailDetails.lastEmail.uploadTime | date: 'MM/dd/yy' | dashIfNothing }}
        </td>
      </ng-container>

      <ng-container matColumnDef="edit">
        <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
        <td
          mat-cell
          *matCellDef="let emailDetails"
          (click)="router.navigate(['/loader-integration-v2/detail', emailDetails.id])"
        >
          <i
            class="material-icons"
            saAutomatedSelector="loader-integration__edit-button"
            (click)="$event.stopPropagation(); addForm(emailDetails)"
            >edit</i
          >
          <i
            class="material-icons delete-icon"
            (click)="$event.stopPropagation(); deleteEmailSettings(emailDetails.id)"
            saAutomatedSelector="loader__delete"
            >delete</i
          >
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let emailDetails; columns: displayedColumns" saAutomatedSelector="loader__row"></tr>
    </table>
  </div>

  <sa-email-form-v2 *ngIf="displayForm" [selectedEmail]="selectedEmail" (goBack)="closeForm()"> </sa-email-form-v2>
</div>
